export function notNull<T>(value: T | null | undefined): T {
    if (value === null || value === undefined) {
        // report error via ErrorReportController::api_frontend_js_error
        throw new Error('Value cannot be null or undefined');
    }
    return value;
}

export function assertString(value: any): asserts value is string  {
    const type = typeof value;
    if (type !== 'string') {
        throw new Error(`Value must be a string; got ${type}`);
    }
}

export function nonEmptyString(value: any): string {
    const type = typeof value;
    if (type !== 'string' || value === '') {
        throw new Error(`Value must be a non-empty string; got ${type}`);
    }
    return value;
}

export function nonEmptyStringOrNull(value: any): string|null {
    if (value === null) {
        return null;
    }
    const type = typeof value;
    if (type !== 'string' || value === '') {
        throw new Error(`Value must be a non-empty string or null; got ${type}`);
    }
    return value;
}

export function notNaN(value: number): number {
    if (isNaN(value)) {
        throw new Error('Value must be a number that is not NaN');
    }
    return value;
}
